var map = {
	"./Assignment.svg": 80031,
	"./Badge.svg": 11013,
	"./Certificate.svg": 47937,
	"./Chatter.svg": 18439,
	"./Company with Employees-grey.svg": 58668,
	"./Compensation.svg": 25114,
	"./Credits.svg": 48426,
	"./Dashboard.svg": 46592,
	"./Directories.svg": 81933,
	"./Directory.svg": 16565,
	"./Employee-portal.svg": 68571,
	"./Employee.svg": 52652,
	"./FairReward.svg": 50351,
	"./Fulfilled.svg": 26525,
	"./Knowledge.svg": 48328,
	"./Manager-portal.svg": 12352,
	"./Menu Dots.svg": 57919,
	"./MyStuff.svg": 75536,
	"./Onboarding.svg": 87367,
	"./Organization-chart.svg": 74770,
	"./Partnership-grey.svg": 66396,
	"./Performance (1).svg": 32384,
	"./Performance.svg": 54054,
	"./Proficiency.svg": 51039,
	"./Readiness.svg": 11212,
	"./Recent Activity.svg": 41436,
	"./Responsibility-assignment.svg": 20568,
	"./Responsibiliy.svg": 74136,
	"./Subscription-grey.svg": 94385,
	"./activity.svg": 83835,
	"./backIcon.svg": 30898,
	"./box.svg": 69711,
	"./clientlogo.svg": 74380,
	"./home-01.svg": 92271,
	"./life-buoy.svg": 45064,
	"./settings.svg": 18971,
	"./users-01.svg": 30960
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 40690;